/** Compact financial formatters: $3.45B, $391B, +0.12%, etc. */

const BILLION = 1_000_000_000;
const MILLION = 1_000_000;
const THOUSAND = 1_000;

export function formatCompactUsd(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === "") return "—";
  const n = typeof value === "string" ? Number(value) : value;
  if (!Number.isFinite(n)) return "—";
  const abs = Math.abs(n);
  if (abs >= BILLION) return `$${(n / BILLION).toFixed(abs >= 100 * BILLION ? 0 : 2)}B`;
  if (abs >= MILLION) return `$${(n / MILLION).toFixed(2)}M`;
  if (abs >= THOUSAND) return `$${(n / THOUSAND).toFixed(2)}K`;
  return `$${n.toFixed(2)}`;
}

export function formatPrice(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === "") return "—";
  const n = typeof value === "string" ? Number(value) : value;
  if (!Number.isFinite(n)) return "—";
  return `$${n.toFixed(2)}`;
}

export function formatPct(value: number | null | undefined, digits = 2, withSign = true): string {
  if (value === null || value === undefined) return "—";
  if (!Number.isFinite(value)) return "—";
  const sign = withSign && value >= 0 ? "+" : "";
  return `${sign}${value.toFixed(digits)}%`;
}

export function formatPctOfFraction(
  value: number | null | undefined,
  digits = 2,
  withSign = true,
): string {
  if (value === null || value === undefined) return "—";
  return formatPct(value * 100, digits, withSign);
}

export function formatInt(value: number | null | undefined): string {
  if (value === null || value === undefined) return "—";
  return value.toLocaleString();
}

export function formatRelativeHours(iso: string | null | undefined, now = Date.now()): string {
  if (!iso) return "never";
  const t = new Date(iso).getTime();
  if (!Number.isFinite(t)) return "never";
  const hours = Math.max(0, Math.round((now - t) / 3_600_000));
  if (hours < 1) return "< 1h ago";
  if (hours < 48) return `${hours}h ago`;
  return `${Math.round(hours / 24)}d ago`;
}
